import PointAndClick from './PointAndClick.js';

import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import { tags } from '../../consts/Tags.js';
import SoundManager from '../../prefabs/SoundManager.js';


export default class Chapitre3_0 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre3_0"
        })
    }

    init(data){
        this.audioName = 'ImmovableMountain';
        super.init(data);   

        this.employeSoundLoop = null
    }

    create(){
        super.create();

        // Ajout popup d'intro
        this.popupIntro = new PopUpBlue(this, this.width/2, this.height/2, 710, 470)
        this.popupIntro.setAlpha(0);


        let introText = "Whaou ! Le laboratoire est gigantesque ! L’entreprise a l’air de prospérer.\n\nUn vigile monte la garde devant l’entrée. Pénétrer dans l’usine ne sera pas simple. Il va falloir être astucieux.";
        let popupIntroText = this.add.text(0, 0, introText, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            lineSpacing: 8,
            align: 'center',
            wordWrap: { width: 600 }
        }).setOrigin(0.5, 0);
        this.popupIntro.addElementToBody(popupIntroText, 40);

        let buttonCloseIntro = new ButtonRounded(this, 0, 0,  { 
            text: "Explorer les environs",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        });
        this.popupIntro.addElementToBody(buttonCloseIntro, 40);
        buttonCloseIntro.y+= buttonCloseIntro.height/2
        buttonCloseIntro.setClickFunction( () => {
           this.popupIntro.animOut(() => {
                this.popupIntro.destroy(true);
                this.displayButtons();
            });
        })

        this.popupIntro.animIn()
    }


    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "employe"){
            this.opeinIndiceEmploye(id, data);
        }else if(data.type == "vigile"){
            this.openIndiceVigile(id, data);
        }
    }

    opeinIndiceEmploye(id, data){
        this.openIndice(id);
        if(this.chapitreProgression.employe.locked){
            this.setEmployeLocked(data);
        }
        this.employeSoundLoop = this.soundManager.playLoop('EmployeSieste')
    }

    setEmployeLocked(data){
        this.popup.setBackground(data.imageKey2)
        this.popup.setText(data.description2)
        this.popup.closeButton.x = -174

        // Ajout bouton rentrer dans l'usine
        let closeButton = new ButtonRounded(this, 78, this.popup.background.height / 2 - 30, { 
            text: "Emprunter ses affaires",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
        });
        this.popup.add(closeButton);
        closeButton.setClickFunction( () => {
            // MAJ progression
            this.chapitreProgression.employe.locked = false;
            this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);

            closeButton.destroy();
            this.popup.closeButton.x = 0
            this.popup.setBackground(data.imageKey)
            this.popup.setClickFunction( () => {this.closePopup()})
            this.tweens.add({
                targets: this.popup.textElmt,
                alpha: 0,
                duration: 200,
                onComplete: () => {
                    this.popup.setText(data.description)
                    this.tweens.add({
                        targets: this.popup.textElmt,
                        alpha: 1,
                        duration: 200
                    })
                }
            })
        })
    }

    openIndiceVigile(id, data){
        this.openIndice(id);
        if(!this.chapitreProgression.employe.locked){
            this.setVigileUnlocked(data);
            this.soundManager.playOnce('VigileYes')
        }else{
            this.soundManager.playOnce('VigileNo')
        }
    }

    setVigileUnlocked(data){
        this.popup.setBackground(data.imageKey2)
        this.popup.setText(data.description2)
        this.popup.closeButton.x = -174

        // Ajout bouton rentrer dans l'usine
        let closeButton = new ButtonRounded(this, 78, this.popup.background.height / 2 - 30, { 
            text: "Rentrer dans l'entrepôt",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
        });
        closeButton.setClickFunction( () => {
            this.finChapitre();
        } )
        this.popup.add(closeButton);
    }

    finChapitre(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre3_1")
            }
        })
    }

    closePopup(){
        super.closePopup();
        if(this.employeSoundLoop){
            this.employeSoundLoop.stop();
        }
    }
}